module.exports = __webpack_public_path__ + "img/settingsNine.0dc2e06f.svg";